export default __webpack_public_path__ + "static/media/Dios-5.54919579.png";